module.exports = __webpack_public_path__ + "img/gift_used_1.99ad756a.png";